import React from 'react';
import styled from 'styled-components';
import InfoIcon from '@ingka/ssr-icon/paths/information';
import Button from 'ui/Button/Button';
import Switch from '@ingka/switch';

const SwitchInfoButton = styled(Button)`
  background: white;
  border: white solid 2px;
  &:focus {
    outline: 0.125rem solid ${({ theme }) => theme.colors.feedback.focus};
    border-radius: 50%;
  }
`;

const SwitchWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

interface Props {
  id: string;
  value: string;
  checked: boolean;
  handleChange: () => void;
  label: string;
  onInfoButtonClick?: () => void;
  disabled?: boolean;
}

const SkapaSwitch = ({
  id,
  value,
  checked,
  handleChange,
  label,
  onInfoButtonClick,
  disabled
}: Props) => {
  return (
    <SwitchWrap>
      <Switch
        id={id}
        value={value}
        checked={checked}
        label={label}
        onChange={handleChange}
        disabled={disabled}
      />
      {onInfoButtonClick && (
        <SwitchInfoButton
          onClick={() => onInfoButtonClick()}
          ssrIcon={InfoIcon}
          aria-label="toggle"
        />
      )}
    </SwitchWrap>
  );
};

export default SkapaSwitch;
